import { AuthService } from '../shared/auth/auth.service';
import { Injectable } from '@angular/core';
import { Http, Response, URLSearchParams } from '@angular/http';
import { BaseService } from '../shared/service/base.service';
import { FBData } from './fb-data.model';
import { Observable } from 'rxjs';

@Injectable()
export class FBPostsService extends BaseService<FBData[]> {

  constructor(_authService: AuthService,
    _http: Http) {
    super('https://graph.facebook.com/itherapeutics.au/feed?limit=20&locale=en_GB&access_token=1585676645032736|ue_Gkk17x0KPwG0_3PidVRLd2ts&fields=id,from,created_time,message,picture,link,caption,actions,status_type,likes,name',
    _authService, _http);
  }
  getFBPosts(){
    return this._http.get(this._baseUrl)
      .map((res: Response) => res.json())
      ;
  }
}



// WEBPACK FOOTER //
// ./src/app/facebook-posts/fb-posts-service.ts